var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"slot":"main","id":"app"},slot:"main"},[_vm._t("default"),(!_vm.openAppModalOnSelf && !_vm._isServer)?_c('openAppModel',{attrs:{"link":_vm.toAppLink},model:{value:(_vm.isShowOpenAppModel),callback:function ($$v) {_vm.isShowOpenAppModel=$$v},expression:"isShowOpenAppModel"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }